import type { Organization } from "@App/types";
import { gql } from "@apollo/client";

export interface ContractDetailsPickupQuery {
  organization: Organization;
}

export const GET_CONTRACT_DETAILS_PICKUP = gql`
    query getContractDetailsPickup(
        $organization: ID!
        $agreementNumber: String!
        $numberPlate: String
    ) {
        organization(id: $organization) {
            id
            uuid
            name
            contractDetailsPickUp(agreementNumber: $agreementNumber, numberPlate: $numberPlate) {
                carId
                agreementNumber,
                name,
                email,
                country,
                street,
                city,
                postcode,
                phone,
                contractEndDate
            }
        }
    }
`;
